

















import { Component, Prop, Vue } from 'vue-property-decorator';
import PageBanner from '@/components/PageBanner.vue';
import SingleServiceTab from '@/components/SingleServiceTab.vue';
import { getImgUrl } from '../utils/dummy';
import { HOST } from '@/global';

import {
  TimelineMax,
  CSSPlugin,
  CSSRulePlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';

@Component({
  name: 'SingleService',
  components: {
    SingleServiceTab
  }
})
export default class SingleService extends Vue {
  @Prop() compData: any;
  HOST: string = HOST;
  currentIndex: number = 0;
  nextSlide() {
    if (this.currentIndex < this.compData.contents.length - 1)
      this.currentIndex++;
  }
  prevSlide() {
    if (this.currentIndex > 0) this.currentIndex--;
  }
}
